/**
 * Cache-busting URL for unhashed asset files that the portal reads at runtime
 * (`releases.json`, `roadmap-longterm.json`).
 *
 * BUG-008 #38: until 0.72.11 nginx served `assets/releases.json` without a
 * `Cache-Control` header, and browsers kept a heuristic copy for days, so the
 * version badge showed 0.72.6 while the pilot served 0.72.9. The header fix
 * stops new stale copies but cannot evict the ones browsers already hold. A
 * changing query string makes every request a cache miss, on every client,
 * without a manual reload. The server marks these files `no-store`, so the
 * query string costs nothing.
 */
export function assetUrl(path: string, now: number = Date.now()): string {
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}v=${now}`;
}

export const RELEASES_JSON = '/assets/releases.json';
export const ROADMAP_LONGTERM_JSON = '/assets/roadmap-longterm.json';
